import styled from '@emotion/styled';

import Card from 'components/global/Card';
import Image from 'components/global/Image';

import { Breakpoints } from 'utils/const.styles';

export const PageContainer = styled(Card)`
	display: flex;
	flex-direction: column;
	padding: 4.5rem 3rem;
	overflow-x: hidden;
`;

export const ProductNotFound = styled(Card)`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
`;

export const DetailBox = styled.div`
	display: flex;
	flex-direction: column;
	${({ gap }) => gap && `gap: ${gap};`}
	&.mb-2-5 {
		margin-bottom: 2.5rem;
	}
	.description {
		white-space: pre-wrap;
	}
`;

export const ProductDetailsContainer = styled.div`
	display: flex;
	gap: 3rem;
	@media ${Breakpoints.mobileLandscape} {
		flex-direction: column;
	}
`;

export const DetailsContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const ImageContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 45rem;
	@media ${Breakpoints.xldesktop} {
		width: 55%;
	}
	@media ${Breakpoints.desktop} {
		width: 55%;
	}
	@media ${Breakpoints.tablet} {
		width: 55%;
	}
	@media ${Breakpoints.mobileLandscape} {
		width: 100%;
	}
`;

export const SwiperArea = styled.div`
	width: 100%;
	.swiper-button-next,
	.swiper-button-prev {
		width: auto;
	}
	.swiper-button-next:after,
	.swiper-rtl .swiper-button-next:after,
	.swiper-button-prev:after,
	.swiper-rtl .swiper-button-prev:after {
		font-size: 2rem;
		font-weight: bold;
		background: #b3b3b384;
		color: var(--white);
		opacity: 1;
		padding: 1rem;
		width: 4rem;
		height: 4rem;
		text-align: center;
		border-radius: 50%;
	}
`;

export const ProductImage = styled(Image)`
	border-radius: 0.5rem;
	width: 100%;
	height: 45rem;
	min-height: 45rem;
	object-fit: scale-down;
`;

export const ProductThumbCarousel = styled.div`
	display: flex;
	width: auto;
	gap: 1.35rem;
	overflow-x: auto;
	overflow-y: hidden;
	scroll-snap-type: x mandatory;
	scroll-behavior: smooth;
	-webkit-overflow-scrolling: touch;
	margin-top: 1rem;
`;

export const ProductThumb = styled(Image)`
	scroll-snap-align: center;
	object-fit: scale-down;
`;

export const ProductThumbButton = styled.div`
	box-sizing: border-box;
	cursor: pointer;
	user-select: none;
	border: 1px solid ${({ isActive }) => (isActive ? 'var(--blue)' : 'transparent')};
`;

export const Line = styled.span`
	height: 1px;
	min-height: 1px;
	background-color: var(--border-color);
	width: 100%;

	margin: 1rem auto;
	display: block;
`;

export const SizeDetail = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const SizeButton = styled.div`
	padding: 0.5rem 1rem;
	border: 1px solid var(--border-color);
	width: fit-content;
	border-radius: 0.5rem;
`;

export const ActionContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	margin-top: 1rem;
`;

export const ProductQuantityContainer = styled.div`
	min-width: 16rem;
	width: 100%;
`;

export const CurrencyText = styled.span`
	font-weight: 700;
	font-size: var(--paragraph1-font-size);
`;

export const ProductDetailsBottomContainer = styled.div`
	padding: 2rem 0;
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;
